import { httpInterceptor } from '../http-interceptor';

export class CellService {
  static ENDPOINTS = {
    GET_ALL: 'Machine/getAllMachinesNew',
    GET_MACHINE_DETAILS_BY_ID: 'Machine/getMachineDetailsById',
    GET_ALL_LANE_NAMES:'Machine/getAllLaneNames',
    GET_ALL_MAINTENANCE_RECORDS: 'Machine/getAllMaintenanceRecords',
    GET_MACHINE_DETAILS_BY_ASSETNUMBER: 'Machine/getMachineDetailsByAsstNo',
    GET_MACHINE_MAINTENANCE_BY_ID: 'Machine/getMachineMainteneanceById',
    GET_ALL_MAINTENANCE_RECORDS_BY_MACHINE:'Machine/getAllMaintenanceRecordsBYMachineId',
    GET_MACHINE_SAFETY_CHECKLIST_BY_MACHINE: 'Machine/machineSafetyChecklistByMachine',
    GET_MAINTENANCE_RECORDS_DETAILS: 'Machine/getMaintenanceRecordsDetails', ///{MaintenanceId}/{MachineId}/{WorkOrderNumber}
    GET_ALL_MACHINE_MAINTENANCE_BY_ASSETNUMBER:'Machine/getAllMachineMainteneanceByAsstNo',
    GET_MACHINE_MAINTENANCE_IMAGE_SEGMENTS: 'Machine/getMachineMaintenanceImageSegments',
    SAVE_NEW_MACHINE: 'Machine/saveNewMachine',
    SAVE_MACHINE_MAINTENANCE_DETAILS: 'Machine/SaveOrUpdateMachineMaintenance',
    SAVE_MACHINE_MAINTENANCE_ALL_RECORDS: 'Machine/saveMachineMaintenanceAllRecords',
    SAVE_MACHINE_SAFETY_CHECKLIST: 'Machine/saveOrUpdateMachineSafetyChecklist',
    DELETE_SAFETY_CHECKLIST:'Machine/deleteMachineSafetyChecklist',
    DOWNLOAD: 'Machine/download'
  };

  static async getAllMachinesNew(data) {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL, data);
  }

  static async getMachineDetailsById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MACHINE_DETAILS_BY_ID}/${id}`);
  }
  static async getAllLaneNames() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_LANE_NAMES);
  }
  static async getAllMaintenanceRecords() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_MAINTENANCE_RECORDS);
  }
  static async getMachineDetailsByAssetNumber(AssetNumber) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_MACHINE_DETAILS_BY_ASSETNUMBER}/${AssetNumber}`,
    );
  }
  static async getMachineMaintenanceById(id) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_MACHINE_MAINTENANCE_BY_ID}/${id}`);
  }
  static async getAllMaintenanceRecordsByMachineId(machineId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_ALL_MAINTENANCE_RECORDS_BY_MACHINE}/${machineId}`,
    );
  }
  static async getMachineSafetyChecklistByMachine(machineId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_MACHINE_SAFETY_CHECKLIST_BY_MACHINE}/${machineId}`,
    );
  }

  static async getMaintenanceRecordsDetails(maintenanceId, machineId, WorkOrderNumber) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_MAINTENANCE_RECORDS_DETAILS}/${maintenanceId}/${machineId}/${WorkOrderNumber}`,
    );
  }

  static async getAllMachineMaintenanceByAssetNumber(assetNumber) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_ALL_MACHINE_MAINTENANCE_BY_ASSETNUMBER}/${assetNumber}`,
    );
  }

  static async getMachineMaintenanceImageSegments(category, record, maintenanceId) {
    return httpInterceptor.get(
      `${this.ENDPOINTS.GET_MACHINE_MAINTENANCE_IMAGE_SEGMENTS}/${category}/${record}/${maintenanceId}`,
    );
  }
  static async createMachine(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_NEW_MACHINE, data);
  }

  static async createMachineMaintenanceAllRecords(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MACHINE_MAINTENANCE_ALL_RECORDS, data);
  }

  static async createMachineMaintenanceDetails(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MACHINE_MAINTENANCE_DETAILS, data);
  }

  static async createMachineSafetyChecklist(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_MACHINE_SAFETY_CHECKLIST, data);
  }

  static async uploadDocument(documentData) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, documentData);
  }
  
  static async deleteSafetyChecklist(id) {
    return httpInterceptor.delete(`${this.ENDPOINTS.DELETE_SAFETY_CHECKLIST}/${id}`);
  }

  static async downloadMachine(data) {
    return httpInterceptor.post(`${this.ENDPOINTS.DOWNLOAD}`, data);
  }
}
